import { Contract } from '../../../models/Entities/Contracts/Contract';
import { ContractNegotiation } from '../../../models/Entities/Contracts/ContractNegotiation';
import { ContractNegotiationVersion } from '../../../models/Entities/Contracts/ContractNegotiationVersion';
import { ContractNegotiationVersionConcept } from '../../../models/Entities/Contracts/ContractNegotiationVersionConcept';
import { AppState } from '../../../redux/reducers';
import * as ContractNegotiationVersionConceptStore from '../../../redux/middleware/ContractNegotiationVersionConceptMiddleware';

export interface OwnProps {
  contractNegotiationVersionId: string;
  contractNegotiationId: string;
  contractId: number;
}

interface ConnectedProps {
  versionConcepts: ContractNegotiationVersionConcept[];
  isLoading: boolean;
  errorMessage?: string;
}

interface DispatchProps {
  GetContractNegotiationVersionConcepts: typeof ContractNegotiationVersionConceptStore.actionCreators.GetContractNegotiationVersionConcepts;
  CreateContractNegotiationVersionConcept: typeof ContractNegotiationVersionConceptStore.actionCreators.CreateContractNegotiationVersionConcept;
  UpdateContractNegotiationVersionConcept: typeof ContractNegotiationVersionConceptStore.actionCreators.UpdateContractNegotiationVersionConcept;
  DeleteContractNegotiationVersionConcept: typeof ContractNegotiationVersionConceptStore.actionCreators.DeleteContractNegotiationVersionConcept;
}

export type Props = OwnProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: OwnProps): ConnectedProps => {
  const contract: Contract | undefined =
    state.Contract?.list?.find((c: Contract) => c.id === ownProps.contractId);
  const negotiation: ContractNegotiation | undefined =
    contract?.negotiations?.find((n) => n.id === ownProps.contractNegotiationId);
  const version: ContractNegotiationVersion | undefined =
    negotiation?.versions?.find((v) => v.id === ownProps.contractNegotiationVersionId);

  return {
    versionConcepts: version?.concepts || [],
    isLoading: version?.isGettingVersionConcepts || false,
    errorMessage: version?.ErrorGettingVersionConcepts?.ErrorMessage,
  };
};

export const mapDispatchToProps: DispatchProps = {
  GetContractNegotiationVersionConcepts:
    ContractNegotiationVersionConceptStore.actionCreators.GetContractNegotiationVersionConcepts,
  CreateContractNegotiationVersionConcept:
    ContractNegotiationVersionConceptStore.actionCreators.CreateContractNegotiationVersionConcept,
  UpdateContractNegotiationVersionConcept:
    ContractNegotiationVersionConceptStore.actionCreators.UpdateContractNegotiationVersionConcept,
  DeleteContractNegotiationVersionConcept:
    ContractNegotiationVersionConceptStore.actionCreators.DeleteContractNegotiationVersionConcept,
};
